import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EllipsisComponent } from './ellipsis.component';
import { EllipsisDirective } from './ellipsis.directive';

@NgModule({
  declarations: [EllipsisComponent, EllipsisDirective],
  exports: [EllipsisComponent, EllipsisDirective],
  entryComponents: [EllipsisComponent],
  imports: [CommonModule]
})
export class EllipsisModule {}

export { EllipsisDirective, EllipsisComponent };
